export const REDIRECT = "redirect";
export const SAME_MODAL = "sameModal";
export const FAQS = "FAQs";
export const WHATSNEW = "See what’s new?";
export const CHAT = "Chat";
export const MEETING_REQUEST = "Request a meeting";
export const SEE_WHATS_NEW = "See what’s new";
export const WHATSAPP = "WhatsApp";
export const PHONE = 16282774045;
export const CONTACT_US = "Contact us";
export const EMAIL = "Send us an email";
export const BOOK_A_DEMO = "Book a demo";

// Help Card Types
export const SUPPORT_EXECUTIVE = "Support Executive";
export const SUPPORT_TEAM = "Support Team";
export const TAX_PREPARER = "Tax Preparer";
export const BOOKKEEPING_EXPERT = "Bookkeeping Expert";
export const CEO = "CEO";
export const ACCOUNT_MANAGER = "Account manager";
